
import React from "react";

class Head extends React.Component {

  componentWillUnmount() {
    const links = document.querySelectorAll("head link");
  
    links.forEach(link => {
      document.head.removeChild(link);
    });
  }

  componentDidMount() {
    const json = {
      "links": [
        {
          "href": "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css",
          "rel": "stylesheet",
          "integrity": "sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH",
          "crossOrigin": "anonymous"
        },
        {
          "href": "https://fonts.googleapis.com/css2?family=Mynerve&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          "rel": "stylesheet"
        },
        {
          "href": "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.1/css/all.min.css",
          "rel": "stylesheet",
          "integrity": "sha512-5Hs3dF2AEPkpNAR7UiOHba+lRSJNeM2ECkwxUIxC1Q/FLycGTbNapWXB4tP889k5T5Ju8fs4b1P5z/iB4nMfSQ==",
          "crossOrigin": "anonymous",
          "referrerPolicy": "no-referrer"
        }
      ]
    }

    json.links.forEach(linkData => {
      const linkElement = document.createElement("link");
    
      Object.entries(linkData).forEach(([key, value]) => {
        linkElement.setAttribute(key, value);
      });
    
      document.head.appendChild(linkElement);
    });
   
  }


  render(){
    return (
        <head>
          <meta charset="utf-8"/>
          <meta name="viewport" content="width=device-width, initial-scale=1"/>
          <title>Sigmobi</title>
        </head>    
    );
  }

  
}

export default Head;

